const NETWORK_ERROR_PATTERN = /failed to fetch|networkerror|load failed|network request failed/i;

export function isLikelyNetworkFetchError(error: unknown): boolean {
  if (!(error instanceof Error)) {
    return false;
  }

  return NETWORK_ERROR_PATTERN.test(error.message);
}

export function mapNetworkFetchError(
  error: unknown,
  fallback = 'Sem conexão com o servidor. Verifique a internet e tente novamente.',
): Error {
  if (error instanceof Error) {
    if (isLikelyNetworkFetchError(error)) {
      return new Error(fallback);
    }

    return error;
  }

  return new Error(fallback);
}
